import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DesignSystemModule } from '@hit/coverpath-design-system';

/* Feature Modules */
import { PaymentFormComponent } from './components/payment-form-component/paymentForm';
import { FormCompleteComponent } from './components/form-complete/complete.component';
import { PaymentUpdateComponent } from './components/app-component/app.component';
import { ModalComponent } from './components/modal/modal.component';
import { AuthStatementComponent } from './components/auth-statement/auth.statement.component';
import { PaymentFormSubheadComponent } from './components/payment-form-subhead/payment.form.subhead.component';

import { ModalService } from '../common/service/modal.service';
import { ModalRouteService } from '../common/service/modal-route.service';
import { PaymentService } from '../common/service/payment.service';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { WindowService } from '../../../../angular-shared/services/window/window.service';

import { PaymentFormComponentCoverPath } from './components/payment-form-component/coverpath/paymentForm.coverpath';
import { BaseFormModule } from '../../../../../coverpath-common/angular/components/form/base-form.module';
import { PaymentFormComponentMMDirect } from './components/payment-form-component/mmdirect/paymentForm.mmdirect';
import { FormCompleteComponentMMDirect } from './components/form-complete/mmdirect/complete.component.mmdirect';
import { FormCompleteComponentCoverpath } from './components/form-complete/coverpath/complete.component.coverpath';
import { BankAccountFormComponentCoverpath } from '../common/forms/bank-account/coverpath/bank-account-form.coverpath';
import { BankAccountFormComponentMMDirect } from '../common/forms/bank-account/mmdirect/bank-account-form.mmdirect';
import { SafeUrlPipe } from '../../../../../coverpath-common/angular/classes/safe-url.pipe';
import { AuthorizePaymentBankAccountForm } from '../../../../../coverpath-common/angular/components/account-center/AuthorizePaymentBankAccountForm/authorize-payment-bank-account-form.component';

@NgModule({
  imports: [
    // BrowserModule,
    HttpClientModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    BaseFormModule,
    DesignSystemModule,
    // RouterModule.forRoot(appRoutes)
  ],
  exports: [
    PaymentFormComponent,
    FormCompleteComponent,
    PaymentUpdateComponent,
    ModalComponent,
    AuthStatementComponent,
    PaymentFormSubheadComponent,
    PaymentFormComponentCoverPath,
    PaymentFormComponentMMDirect,
    FormCompleteComponentCoverpath,
    FormCompleteComponentMMDirect,
    BankAccountFormComponentMMDirect,
    BankAccountFormComponentCoverpath,
    AuthorizePaymentBankAccountForm,
  ],
  declarations: [
    PaymentFormComponent,
    FormCompleteComponent,
    PaymentUpdateComponent,
    ModalComponent,
    AuthStatementComponent,
    PaymentFormSubheadComponent,
    PaymentFormComponentCoverPath,
    PaymentFormComponentMMDirect,
    FormCompleteComponentCoverpath,
    FormCompleteComponentMMDirect,
    BankAccountFormComponentMMDirect,
    BankAccountFormComponentCoverpath,
    AuthorizePaymentBankAccountForm,
    SafeUrlPipe,
  ],
  providers: [ModalService, ModalRouteService, PaymentService, AmorphicService, WindowService],
  bootstrap: [PaymentUpdateComponent],
})
export class WidgetPaymentCustomerModule {}
